export const LogoCircle = (props: React.ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        fill="url(#a)"
        fillRule="evenodd"
        d="M8 1.25c-2.62 0-4.75 2.13-4.75 4.75v2.6l-1.15 2.3c-.33.63.13 1.4.85 1.4h10.1c.72 0 1.18-.77.85-1.4l-1.15-2.3V6c0-2.62-2.13-4.75-4.75-4.75Zm-1.75 11.8a1.79 1.79 0 0 0 3.5 0h-3.5Z"
        clipRule="evenodd"
      />
      <path
        fill="url(#c)"
        fillRule="evenodd"
        d="M8 1.25c-2.62 0-4.75 2.13-4.75 4.75v2.6l-1.15 2.3c-.33.63.13 1.4.85 1.4h10.1c.72 0 1.18-.77.85-1.4l-1.15-2.3V6c0-2.62-2.13-4.75-4.75-4.75Zm-1.75 11.8a1.79 1.79 0 0 0 3.5 0h-3.5Z"
        clipRule="evenodd"
      />
      <defs>
        <linearGradient id="c" x1="8" x2="8" y1="1.999" y2="13.999" gradientUnits="userSpaceOnUse">
          <stop offset=".547" stopOpacity="0" />
          <stop offset="1" stopOpacity=".25" />
        </linearGradient>
        <radialGradient
          id="a"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(-6 6 -6 -6 8 8)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset=".34" stopColor="#FF006A" />
          <stop offset=".613" stopColor="#E300BD" />
          <stop offset=".767" stopColor="#FF4CE1" />
        </radialGradient>
      </defs>
    </svg>
  );
};
